export const educationData = [
    {
        id: 1,
        institution: 'E.E.S N° 41 "Profesor José A. Gotusso"',
        course: 'Secondary Education',
        startYear: 'Mar, 2016',
        endYear: '  Nov, 2020'
    },
    {
        id: 2,
        institution: '"Like It English" Academy in Machagai',
        course: 'A1, A2, B1 and B2 English Language',
        startYear: '2017',
        endYear: '2020'
    },
    {
        id: 3,
        institution: '"SoyHenry" Bootcamp',
        course: 'Full Stack Developer',
        startYear: 'Ago, 2022',
        endYear: 'Jan, 2023'
    },
]